export default __webpack_public_path__ + "static/media/portfolio2.7d4968dd.jpg";